import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=73985f91&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73985f91')) {
      api.createRecord('73985f91', component.options)
    } else {
      api.reload('73985f91', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=73985f91&", function () {
      api.rerender('73985f91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22a5O1PPu9upJ/JS/comp/FavElement.vue"
export default component.exports